import { MIXPANEL_EVENT } from "@/Poker/data/Constants";
import { getLobbySlice } from "@/Poker/utils/ReduxUtils";

export const messageToNativeClient = (data) => {
  try {
    if (data.type === MIXPANEL_EVENT) {
      if (import.meta.env.VITE_REACT_APP_LOGGING_MIXPANEL_EVENTS==="false") {
        console.warn("Turned off Mixpanel Events Logging");
        return;
      }
     
    }
    data = JSON.stringify(data);
    let userAgent = window.navigator.userAgent.toLocaleLowerCase();
    let date = new Date();
    console.log(
      `Message to Platform ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()} >>> ${data}`
    );
    if (userAgent.indexOf("android") === -1) {
      //iOS webview
      window.webkit.messageHandlers.RedirectTo.postMessage(data);
    } else if (userAgent.toString().includes("wv")) {
      //android webview
      window.android.redirectTo(data);
    } else {
      console.warn("Client is not in webview, unable to send message: ", data);
    }
  } catch (e) {
    console.log("Error occured ..");
  }
};

export const plotlineEventCallbackToNative = (
  eventNameKey,
  eventPropertiesObj
) => {
  /* @Sneha: IM-5056
   the below check is temporary only for the plotline events until the mandatory upgrad is not done in production , post that in next relase the check can be removed and only the plotlineEvent key to be sent */
  console.log("SNEHA LOG >> isCleverTapEnabledFromNative ",getLobbySlice()?.isCleverTapEnabledFromNative);
  let key = getLobbySlice()?.isCleverTapEnabledFromNative
    ? "plotlineEvent"
    : "plotlineEvents";
  messageToNativeClient({
    type: key,
    eventName: eventNameKey,
    eventProperties: eventPropertiesObj,
  });
};
